<template>
  <div>
    <v-card color="grey lighten-1 white--text">
      <v-layout align-center row>
        <v-flex xs6 md6 pl-3> Driver Groups </v-flex>
      </v-layout>
    </v-card>
    <v-card
      :href="'/settings/driver_group/edit/'+dg.id"
      v-for="dg in driverGroups"
      :key="dg.id"
      :color="dg.enabled ? 'white' : 'grey lighten-2'"
    >
      <v-layout align-center row>
        <v-flex xs4 md4>
          <v-card-title
            ><h4>{{ dg.name }}</h4></v-card-title
          >
        </v-flex>
      </v-layout>
    </v-card>
  </div>
</template>

<script>
import draggable from "vuedraggable";

export default {
  name: "ride_type_list",
  components: {
    draggable,
  },
  props: {
    driverGroups: Array
  },
  data: function () {
    return {
    
    };
  },
  beforeMount: async function () {
  },
  methods: {
  },
};
</script>
